/*!
 * OS.js - JavaScript Cloud/Web Desktop Platform
 *
 * Copyright (c) 2011-2017, Anders Evenrud <andersevenrud@gmail.com>
 * All rights reserved.
 *
 * Redistribution and use in source and binary forms, with or without
 * modification, are permitted provided that the following conditions are met:
 *
 * 1. Redistributions of source code must retain the above copyright notice, this
 *    list of conditions and the following disclaimer
 * 2. Redistributions in binary form must reproduce the above copyright notice,
 *    this list of conditions and the following disclaimer in the documentation
 *    and/or other materials provided with the distribution
 *
 * THIS SOFTWARE IS PROVIDED BY THE COPYRIGHT HOLDERS AND CONTRIBUTORS "AS IS" AND
 * ANY EXPRESS OR IMPLIED WARRANTIES, INCLUDING, BUT NOT LIMITED TO, THE IMPLIED
 * WARRANTIES OF MERCHANTABILITY AND FITNESS FOR A PARTICULAR PURPOSE ARE
 * DISCLAIMED. IN NO EVENT SHALL THE COPYRIGHT OWNER OR CONTRIBUTORS BE LIABLE FOR
 * ANY DIRECT, INDIRECT, INCIDENTAL, SPECIAL, EXEMPLARY, OR CONSEQUENTIAL DAMAGES
 * (INCLUDING, BUT NOT LIMITED TO, PROCUREMENT OF SUBSTITUTE GOODS OR SERVICES;
 * LOSS OF USE, DATA, OR PROFITS; OR BUSINESS INTERRUPTION) HOWEVER CAUSED AND
 * ON ANY THEORY OF LIABILITY, WHETHER IN CONTRACT, STRICT LIABILITY, OR TORT
 * (INCLUDING NEGLIGENCE OR OTHERWISE) ARISING IN ANY WAY OUT OF THE USE OF THIS
 * SOFTWARE, EVEN IF ADVISED OF THE POSSIBILITY OF SUCH DAMAGE.
 *
 * @author  Anders Evenrud <andersevenrud@gmail.com>
 * @licence Simplified BSD License
 */
import Promise from 'bluebird';
import PackageManager from 'core/package-manager';
import Transport from 'vfs/transport';
import FileMetadata from 'vfs/file';
import {_} from 'core/locales';

/**
 * Application VFS Transport Module
 *
 * This is a purely virtual module that allows for listing of applications
 * via scandir etc.
 *
 * @extends Transport
 */
export default class ApplicationTransport extends Transport {

  request(method, args, options) {
    if ( ['scandir'].indexOf(method) === -1 ) {
      return Promise.reject(new Error(_('ERR_VFS_UNAVAILABLE')));
    }

    return super.request(...arguments);
  }

  scandir() {
    const metadata = PackageManager.getPackages();
    const files = [];

    Object.keys(metadata).forEach((m) => {
      const iter = metadata[m];
      if ( iter.type !== 'extension' ) {
        files.push(new FileMetadata({
          filename: iter.name,
          type: 'application',
          path: 'applications:///' + m,
          mime: 'osjs/application'
        }, 'osjs/application'));
      }
    });

    return Promise.resolve(files);
  }

  url(item) {
    return Promise.resolve(item.path);
  }

}



// WEBPACK FOOTER //
// ./javascript/vfs/transports/applications.js